import type { Dictionary } from "@kensio/pinyinjs";

import type { ServedTier } from "../segmenting/dictionary.js";
import type { Startup } from "./tool-state.js";

/** Loads the segmenter's dictionary tiers and hands each successful load on. */
export class SegmenterDictionary {
  readonly #startup: Startup;
  readonly #loaded: (dictionary: Dictionary) => void;

  constructor(startup: Startup, loaded: (dictionary: Dictionary) => void) {
    this.#startup = startup;
    this.#loaded = loaded;
  }

  /** Load a dictionary tier and publish it when the reader has one. */
  async load(tier: ServedTier): Promise<void> {
    const dictionary = await this.#startup.tiers.load(tier);

    if (dictionary !== undefined) {
      this.#loaded(dictionary);
    }
  }

  /** Offer the other tiers, and load the one this visit wants. */
  async open(): Promise<void> {
    const { tiers, tier } = this.#startup;

    tiers.wireOffers(this.load.bind(this));
    await this.load(await tiers.opening(tier));
  }
}
